export type Theme =
    'Bright Blue' |
    'Gradient Blue' |
    'Gray' |
    'Blue Gray' |
    'White' |
    'Danger' |
    'Warning' |
    'Info' |
    'Success';

export class Themes {
    public static readonly BRIGHT_BLUE: Theme = 'Bright Blue';
    public static readonly GRADIENT_BLUE: Theme = 'Gradient Blue';
    public static readonly GRAY: Theme = 'Gray';
    public static readonly BLUE_GRAY: Theme = 'Blue Gray';
    public static readonly WHITE: Theme = 'White';
    public static readonly DANGER: Theme = 'Danger';
    public static readonly WARNING: Theme = 'Warning';
    public static readonly INFO: Theme = 'Info';
    public static readonly SUCCESS: Theme = 'Success';
}

export const ThemeClassMap: { theme: Theme, className: string }[] = [
    { theme: Themes.BRIGHT_BLUE, className: 'theme-bright-blue' },
    { theme: Themes.GRADIENT_BLUE, className: 'theme-gradient-blue' },
    { theme: Themes.GRAY, className: 'theme-gray' },
    { theme: Themes.BLUE_GRAY, className: 'theme-blue-gray' },
    { theme: Themes.WHITE, className: 'theme-white' },
    { theme: Themes.DANGER, className: 'theme-danger' },
    { theme: Themes.WARNING, className: 'theme-warning' },
    { theme: Themes.INFO, className: 'theme-info' },
    { theme: Themes.SUCCESS, className: 'theme-success' }
];